/**
 * Writer-facing catalog. Hide tester leftovers and every library pack
 * outside the 24 gi_* anchors (#1295). Not greyed, not counted in All.
 * Books already hung on a retired key still resolve by that key.
 * Custom frameworks are unchanged.
 */

export const QA_WALK_FRAMEWORK_NAMES = new Set([
  'QA Walk Structure',
  'QA Walk Structure Reimported',
]);

export const RETIRED_LIBRARY_IDS = new Set([
  'three_act_novel',
  'story_circle',
  'three_act',
  'five_act',
  'seven_point',
  'eight_sequence',
  'quest_narrative',
  'kishotenketsu',
  'monomyth',
  'investigation_arc',
  'threat_arc',
  'dread_arc',
  'relationship_arc',
  'transformation_arc',
  'voyage_and_return',
  'overcoming_the_monster',
  'rags_to_riches',
  'rebirth_arc',
  'tragedy_arc',
  'coming_of_age',
  'mystery_fair_play',
  'heist_structure',
  'horror_escalation',
  'thriller_countdown',
  'romantic_comedy',
  'buddy_duo',
  'fish_out_of_water',
  'revenge_arc',
  'conspiracy_thriller',
  'psychological_thriller',
  'hunter_hunted',
  'survival_thriller',
  'enemies_to_lovers',
  'second_chance_romance',
  'forbidden_romance',
  'gothic_romance',
  'friends_to_lovers',
  'fake_relationship',
  'marriage_of_convenience',
  'forced_proximity',
  'grumpy_sunshine',
  'secret_identity',
  'small_town_romance',
  'protector_romance',
  'cozy_mystery',
  'noir_mystery',
  'police_procedural',
  // Shipped broads, including hung romance (#1295). Not a new pick.
  'thriller',
  'romance',
  'mystery',
  'fantasy_adventure',
  'horror',
  // First-party packs (#1295). Resolvable when a book is already on one.
  'romance_central_pair',
  'thriller_pursuit',
  'mystery_puzzle',
  'mystery_thriller',
  'mystery_cozy',
  'high_fantasy',
  'secondary_world_magic',
  'thriller_psychological',
  'romance_romantic_suspense',
  'horror_survival_escalation',
  'sf_hard_novum',
  'literary_quiet_causal',
  'heist_crew_caper',
  'fantasy_romantasy_dual',
  'ya_identity_crossing',
  'mystery_noir',
  'mystery_psychological',
  'horror_domestic',
  'crime_outlaw_contest',
]);

export function isWriterFacingCustom(item) {
  const name = (item?.framework_name || '').trim();
  if (QA_WALK_FRAMEWORK_NAMES.has(name)) return false;
  if ((item?.source || '').trim() === 'library') return isWriterFacingLibrary(item);
  return true;
}

export function isWriterFacingLibrary(item) {
  const id = (item?.id || item?.key || '').trim();
  // New picks are the gi_* anchors only. Any other library id stays off the chooser.
  return id.startsWith('gi_') && !RETIRED_LIBRARY_IDS.has(id);
}

export function writerFacingCatalog(catalog = {}) {
  const library = {};
  Object.entries(catalog.library || {}).forEach(([tag, items]) => {
    const kept = (items || []).filter(isWriterFacingLibrary);
    if (kept.length) library[tag] = kept;
  });
  const custom = (catalog.custom || []).filter(isWriterFacingCustom);
  const allCount = custom.length + Object.values(library).reduce(
    (sum, items) => sum + items.length,
    0,
  );
  return { library, custom, allCount };
}
